import apiBase from "./api-base";

// All /api/LoyaltyAdmin/* endpoints are POST and return { success, message, ... }.
// Auth is the dashboard login token (Authorization header), already attached by ApiCore._request.
// RestaurantID must be included in every body; UserID must never be sent.
export default class LoyaltyAdmin extends apiBase {
  constructor(store) {
    const path = "LoyaltyAdmin";
    super(store, path);
  }

  GetSettings(model) {
    return this._request({
      action: "GetSettings",
      method: "POST",
      body: model,
    });
  }
  SaveProgram(model) {
    return this._request({
      action: "SaveProgram",
      method: "POST",
      body: model,
    });
  }
  SaveOrderTypeFactors(model) {
    return this._request({
      action: "SaveOrderTypeFactors",
      method: "POST",
      body: model,
    });
  }
  SaveReward(model) {
    return this._request({
      action: "SaveReward",
      method: "POST",
      body: model,
    });
  }
  SetRewardStatus(model) {
    return this._request({
      action: "SetRewardStatus",
      method: "POST",
      body: model,
    });
  }
  SetRewardLocationOverride(model) {
    return this._request({
      action: "SetRewardLocationOverride",
      method: "POST",
      body: model,
    });
  }
  SaveNonMonetaryConfig(model) {
    return this._request({
      action: "SaveNonMonetaryConfig",
      method: "POST",
      body: model,
    });
  }
  GetReport(model) {
    return this._request({
      action: "GetReport",
      method: "POST",
      body: model,
    });
  }
}
